import { render, staticRenderFns } from "./SelectSubject.vue?vue&type=template&id=84e98b4a&scoped=true&lang=pug&"
import script from "./SelectSubject.vue?vue&type=script&lang=ts&"
export * from "./SelectSubject.vue?vue&type=script&lang=ts&"
import style0 from "./SelectSubject.vue?vue&type=style&index=0&id=84e98b4a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84e98b4a",
  null
  
)

export default component.exports